import { useRouter } from 'next/router';
import { PageType } from './usePageType.types';
import {
  AD_PAGE_SLUGS_COUNT,
  EDIT_AD_PAGE_SLUG,
  EDIT_AD_PAGE_SLUG_INDEX,
  LEGACY_ID_SLUG_INDEX,
} from './usePageType.constants';
import { getCurrentCategoryPath } from '@/hooks/useCurrentCategory/useCurrentCategory.helpers';
import { ROUTES } from '@/constants/routes';

export function usePageType() {
  const { query, asPath } = useRouter();
  const { slug } = query ?? {};
  /** `elanlar/[[...slug]]` passes an array; routes like `/shops/[slug]` pass a string — do not mix up `.length`. */
  const slugSegments = Array.isArray(slug) ? slug : undefined;
  const segmentCount = slugSegments?.length;
  switch (true) {
    case asPath.includes(ROUTES.newAd) ||
      (segmentCount && slugSegments?.[segmentCount - 1] === 'new'):
      return PageType.NewAd;
    case segmentCount === AD_PAGE_SLUGS_COUNT &&
      !Number.isNaN(Number(slugSegments?.[LEGACY_ID_SLUG_INDEX])):
      return PageType.Ad;
    case slugSegments?.[EDIT_AD_PAGE_SLUG_INDEX] === EDIT_AD_PAGE_SLUG:
      return PageType.EditAd;
    case asPath.includes(getCurrentCategoryPath(slug)):
      return PageType.Search;
    default:
      return '' as PageType;
  }
}
